import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.array.find.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import USE_MERCURE from '~/const/mercure';
import logout from '~/helpers/logout-helper';
import * as types from './types';
import { createCart, fetchCart as _fetchCart, addCart, updateCart, addCartCustomizable as _addCartCustomizable } from '~/services/cart';
import { fetchCustomerCart, addCustomerCart, addCustomerCartCustomizable, updateCustomerCart } from '~/services/customer';
import isValidToken from '~/helpers/connection-helper';

var formatCustomerCartQuantity = function formatCustomerCartQuantity(data) {
  var qty = data.split('|').find(function (a) {
    return a.includes('item_qty');
  });
  qty = qty ? qty.replace('item_qty:', '') : 0;
  return parseInt(qty, 10) || 0;
};

var getGraphQLErrorsCode = function getGraphQLErrorsCode(err) {
  if (err && err.length) {
    return err[0].extensions.code || '';
  }

  return '';
};

var initCart = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(context) {
    var _yield$createCart, createNewCart;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            sessionStorage.removeItem('MDM_CART_ADDRESSES');
            sessionStorage.removeItem('MDM_CART_PHONE');
            sessionStorage.removeItem('MDM_RESTORE_CART');
            sessionStorage.removeItem('MDM_CC_ELIGIBLE');
            _context.next = 6;
            return createCart(context, localStorage.getItem('MDM_ACCESS_TOKEN'));

          case 6:
            _yield$createCart = _context.sent;
            createNewCart = _yield$createCart.createNewCart;

            if (createNewCart) {
              _context.next = 10;
              break;
            }

            throw new Error('MDM_CART_CANNOT_CREATE_TOKEN');

          case 10:
            localStorage.setItem('MDM_CART_TOKEN', createNewCart);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function initCart(_x) {
    return _ref.apply(this, arguments);
  };
}();

export default {
  createCart: function createCart() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return initCart(_this);

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  fetchCart: function fetchCart(_ref2) {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var commit, cart, quantity, _yield$_fetchCart, minicart, errors, code, data;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref2.commit;
              cart = null;
              quantity = null;
              _context3.prev = 3;

              if (!USE_MERCURE(_this2.getters['i18n/locale'].iso)) {
                _context3.next = 21;
                break;
              }

              if (localStorage.getItem('MDM_CART_TOKEN')) {
                _context3.next = 7;
                break;
              }

              return _context3.abrupt("return");

            case 7:
              _context3.next = 9;
              return _fetchCart(_this2, localStorage.getItem('MDM_CART_TOKEN'), localStorage.getItem('MDM_ACCESS_TOKEN'));

            case 9:
              _yield$_fetchCart = _context3.sent;
              minicart = _yield$_fetchCart.data.minicart;
              errors = _yield$_fetchCart.errors;

              if (!errors) {
                _context3.next = 16;
                break;
              }

              code = getGraphQLErrorsCode(errors);

              if (code === 'MERCURE_ERROR_CART_NOTFOUND') {
                localStorage.removeItem('MDM_CART_TOKEN');
              }

              throw new Error(errors);

            case 16:
              cart = minicart.items;
              quantity = minicart.quantity;
              commit(types.SET_CART_STATE, 'SUCCESS');
              _context3.next = 27;
              break;

            case 21:
              localStorage.removeItem('MDM_CART_TOKEN');
              _context3.next = 24;
              return fetchCustomerCart(_this2);

            case 24:
              data = _context3.sent;
              quantity = data.cart;

              if (data && data.user) {
                localStorage.setItem('MDM_MAIL', data.user.user_email);
              }

            case 27:
              _context3.next = 33;
              break;

            case 29:
              _context3.prev = 29;
              _context3.t0 = _context3["catch"](3);

              _this2.$logger.error(_context3.t0);

              commit(types.SET_CART_STATE, 'ERROR');

            case 33:
              _context3.prev = 33;
              commit(types.SET_CART, cart);
              commit(types.SET_CART_QTY, quantity);
              return _context3.finish(33);

            case 37:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[3, 29, 33, 37]]);
    }))();
  },
  add: function add(_ref3, payload) {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var commit, state, cart, quantity, item, maxQuantityReached, _yield$addCart, addProductsToCart, errors, totalQuantity, data, currentTotal;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              commit = _ref3.commit, state = _ref3.state;
              cart = null;
              quantity = null;
              _context4.prev = 3;
              item = state.items ? state.items.find(function (p) {
                return p.productReference === payload.reference;
              }) : {};
              maxQuantityReached = item && item.quantity >= 30;

              if (!USE_MERCURE(_this3.getters['i18n/locale'].iso)) {
                _context4.next = 28;
                break;
              }

              if (localStorage.getItem('MDM_ACCESS_TOKEN') && !isValidToken()) {
                logout();
              }

              if (localStorage.getItem('MDM_CART_TOKEN')) {
                _context4.next = 11;
                break;
              }

              _context4.next = 11;
              return initCart(_this3);

            case 11:
              if (maxQuantityReached) {
                _context4.next = 23;
                break;
              }

              _context4.next = 14;
              return addCart(_this3, _objectSpread({
                cart: localStorage.getItem('MDM_CART_TOKEN'),
                token: localStorage.getItem('MDM_ACCESS_TOKEN')
              }, payload));

            case 14:
              _yield$addCart = _context4.sent;
              addProductsToCart = _yield$addCart.data.addProductsToCart;
              errors = _yield$addCart.errors;

              if (!errors) {
                _context4.next = 19;
                break;
              }

              throw new Error({
                message: errors[0].message,
                errorType: 'gql'
              });

            case 19:
              cart = addProductsToCart.items;
              quantity = addProductsToCart.quantity;
              _context4.next = 26;
              break;

            case 23:
              totalQuantity = state.items.reduce(function (acc, pdt) {
                return acc + pdt.quantity;
              }, 0);
              cart = state.items;
              quantity = totalQuantity;

            case 26:
              _context4.next = 34;
              break;

            case 28:
              _context4.next = 30;
              return addCustomerCart(_this3, payload);

            case 30:
              data = _context4.sent;
              currentTotal = state.total;
              cart = [{
                reference: payload.reference,
                productReference: payload.reference,
                quantity: formatCustomerCartQuantity(data)
              }];
              quantity = currentTotal + 1;

            case 34:
              _context4.next = 41;
              break;

            case 36:
              _context4.prev = 36;
              _context4.t0 = _context4["catch"](3);

              if (!_context4.t0.message || _context4.t0.message.indexOf('GraphQL error') === -1) {
                commit(types.SET_CART_SUCCESS_SERVER, false);
              }

              commit(types.SET_CART_SUCCESS, false);

              _this3.$logger.error(_context4.t0);

            case 41:
              _context4.prev = 41;
              commit(types.SET_CART, cart);
              commit(types.SET_CART_QTY, quantity);
              commit(types.SET_CART_SUCCESS, true);
              return _context4.finish(41);

            case 46:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[3, 36, 41, 46]]);
    }))();
  },
  update: function update(_ref4, payload) {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var commit, cart, quantity, reference, items, _yield$updateCart, updateCartItems, data, response;

      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              commit = _ref4.commit;
              cart = null;
              quantity = null;
              reference = null;
              items = _this4.state.cart.items.filter(function (e) {
                return e.productReference === payload.reference;
              });

              if (items.length > 1) {
                reference = items.find(function (e) {
                  return e.offer === payload.offer;
                }).reference;
              } else {
                reference = items[0].reference;
              }

              _context5.prev = 6;

              if (!USE_MERCURE(_this4.getters['i18n/locale'].iso)) {
                _context5.next = 16;
                break;
              }

              _context5.next = 10;
              return updateCart(_this4, {
                cart: localStorage.getItem('MDM_CART_TOKEN'),
                token: localStorage.getItem('MDM_ACCESS_TOKEN'),
                quantity: payload.quantity,
                reference: reference
              });

            case 10:
              _yield$updateCart = _context5.sent;
              updateCartItems = _yield$updateCart.updateCartItems;
              cart = updateCartItems.items;
              quantity = updateCartItems.quantity;
              _context5.next = 24;
              break;

            case 16:
              _context5.next = 18;
              return updateCustomerCart(_this4, payload);

            case 18:
              data = _context5.sent;
              cart = [{
                reference: payload.reference,
                productReference: payload.reference,
                quantity: data.cartItem
              }];
              _context5.next = 22;
              return fetchCustomerCart(_this4);

            case 22:
              response = _context5.sent;
              quantity = response.cart;

            case 24:
              _context5.next = 30;
              break;

            case 26:
              _context5.prev = 26;
              _context5.t0 = _context5["catch"](6);
              commit(types.SET_CART_SUCCESS, false);

              _this4.$logger.error(_context5.t0);

            case 30:
              _context5.prev = 30;
              commit(types.SET_CART, cart);
              commit(types.SET_CART_QTY, quantity);
              commit(types.SET_CART_SUCCESS, true);
              return _context5.finish(30);

            case 35:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[6, 26, 30, 35]]);
    }))();
  },
  addCartCustomizable: function addCartCustomizable(_ref5, payload) {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      var state, commit, currentTotal, _yield$_addCartCustom, addCustomizableProductToCart, data;

      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              state = _ref5.state, commit = _ref5.commit;
              currentTotal = state.total;
              _context6.prev = 2;

              if (!USE_MERCURE(_this5.getters['i18n/locale'].iso)) {
                _context6.next = 17;
                break;
              }

              if (localStorage.getItem('MDM_ACCESS_TOKEN') && !isValidToken()) {
                logout();
              }

              if (localStorage.getItem('MDM_CART_TOKEN')) {
                _context6.next = 8;
                break;
              }

              _context6.next = 8;
              return initCart(_this5);

            case 8:
              _context6.next = 10;
              return _addCartCustomizable(_this5, localStorage.getItem('MDM_CART_TOKEN'), localStorage.getItem('MDM_ACCESS_TOKEN'), payload);

            case 10:
              _yield$_addCartCustom = _context6.sent;
              addCustomizableProductToCart = _yield$_addCartCustom.addCustomizableProductToCart;
              commit(types.SET_CART_QTY, currentTotal + 1);
              commit(types.SET_CART, addCustomizableProductToCart.items);
              commit(types.SET_CART_SUCCESS, true);
              _context6.next = 21;
              break;

            case 17:
              _context6.next = 19;
              return addCustomerCartCustomizable(_this5, payload);

            case 19:
              data = _context6.sent;

              if (data.success) {
                commit(types.SET_CART_QTY, currentTotal + 1);
                commit(types.SET_CART_SUCCESS, true);
              } else {
                commit(types.SET_CART_SUCCESS, false);
              }

            case 21:
              _context6.next = 27;
              break;

            case 23:
              _context6.prev = 23;
              _context6.t0 = _context6["catch"](2);
              commit(types.SET_CART_SUCCESS, false);

              _this5.$logger.error(_context6.t0);

            case 27:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[2, 23]]);
    }))();
  }
};